module.exports = __webpack_public_path__ + "static/media/icon_card_page.df172049.svg";